import {
  Box,
  Flex,
  HStack,
  Tooltip,
  useColorModeValue
} from "@chakra-ui/react";
import { IconNav } from "layouts/components/IconNav";
import { UserDescription } from "layouts/components/UserDescription";
import { RiMenuLine } from "react-icons/ri";
import { DesktopMenu } from "../../components/DesktopMenu";
import { MobileMenu } from "../../components/MobileMenu";

import { Logo } from "layouts/components/Logo";
import logoDark from '_assets/logo-dark.png';
import logoWhite from '_assets/logo-light.png';

export const Header = () => {
  const headerColor = useColorModeValue("white", "gray.900");
  const borderBottom = useColorModeValue("rgb(0 0 0 / 7%)", "rgb(0 0 0 / 30%)");

  const logo = useColorModeValue(logoWhite, logoDark);

  return (
    <Flex
      as="nav"
      px="4"
      position="sticky"
      zIndex="9999"
      top="0"
      w="full"
      bgColor={headerColor}
      borderBottom={`1px solid ${borderBottom}`}
      minH="60px"
    >
      <Flex alignItems="center" mr="4" display={{ base: "flex", lg: "none" }}>
        <MobileMenu />
      </Flex>
      <Flex w="100%" alignItems="center">
        <Logo />
        <HStack ml={4} spacing={3} display={{ base: "none", lg: "flex" }}>
          <Box mr="4">
            <DesktopMenu>
              <Tooltip label="Menu" variant="black">
                <Flex
                  alignItems="center"
                  justifyContent="center"
                  px={4}
                  h="full"
                >
                  <RiMenuLine size="1.3rem" />
                </Flex>
              </Tooltip>
            </DesktopMenu>
          </Box>
        </HStack>
      </Flex>
      <Flex
        w={{ lg: "100%" }}
        alignItems="center"
        justifyContent="flex-end"
        pr={{ base: "0", lg: "10" }}
      >
        <IconNav />
        <UserDescription showName />
      </Flex>
    </Flex>
  );
};
